import React from 'react';
import styles from './ClassPublishedBooksPage.module.scss';

import navigationIcon from '../../../../images/new-dashboard/navigation-icon.svg';
import progressBooksCompleted from '../../../../images/new-dashboard/progress-books-completed.svg';

import PublishedBooks from '../../components/published-books/PublishedBooks';
import { useQuery } from '@apollo/react-hooks';
import { MAIN_DASHBOARD_QUERY } from '../../services/graphql';
import { BOOK_STATUS } from '@squirrellearningltd/go-shared-utils';
import { Link } from '@reach/router';

const ClassPublishedBooksPage = () => {
    const { data, loading, error } = useQuery(MAIN_DASHBOARD_QUERY, {
        fetchPolicy: 'cache-and-network',
    });

    const getBooks = () => {
        const filteredBooks = [];
        const books = data?.currentStudent?.books;

        if (!books) {
            return filteredBooks;
        }

        books.forEach(book => {
            if (book.status >= BOOK_STATUS.completed && !book.classPack?.isWritingActivity) {
                filteredBooks.push(book);
            }
        })

        return filteredBooks;
    }
    return <div className={styles.classPublishedBooksContainer}>
        <div className={styles.publishedBooks}>
            <div className={styles.publishBooksTilteContainer}>
                <img src={progressBooksCompleted} width={57} height={57} alt='Published Books Icon' />
                <h4 className={styles.publishBooksHeadline}>Published Books</h4>
            </div>

            <Link to='/'>
                <div className={styles.publishedBooksLinksContianer}>
                    <h3 className={styles.publishedBooksLinkTitle}>Back to Write</h3>
                    <img src={navigationIcon} alt='Navigation Icon' />
                </div>
            </Link>

        </div>
        <PublishedBooks
            books={getBooks()}
            columns={4}
            imgWidth={381}
            imgHeight={481}
        />
    </div>
}

export default ClassPublishedBooksPage;